import { render, staticRenderFns } from "./ServicePoint.vue?vue&type=template&id=303a53b6&scoped=true"
import script from "./ServicePoint.vue?vue&type=script&lang=js"
export * from "./ServicePoint.vue?vue&type=script&lang=js"
import style0 from "./ServicePoint.vue?vue&type=style&index=0&id=303a53b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303a53b6",
  null
  
)

export default component.exports